import useAnalytics from '@hooks/use-analytics'
import NextLink from 'next/link'
import { AnalyticsLink } from '@components/analytics'
import type { SPContext } from '@hooks/use-analytics'
import { type Dispatch, type SetStateAction } from 'react'
import { type TypePlacePublic } from '@lib/location-types'
import { Button, Icon, Link, Typography, Modal } from '@shc/ui'

type NonSRSLabModalProps = {
  isModalOpen: boolean
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
  placeId: TypePlacePublic['id']
  url: TypePlacePublic['url']
}

const SRSLABSLINK = '/search/locations?q=sharp+rees-stealy&place_type_facet=Labs&v=1'

const NonSRSLabModal = ({ isModalOpen, setIsModalOpen, placeId, url }: NonSRSLabModalProps) => {
  // Analytics tracking vars
  const objectId = placeId?.toString() ?? '-1'
  const namespace = 'places'
  const { trackSnowplow } = useAnalytics()
  const contexts: SPContext[] = [
    {
      name: 'modal',
      data: { modal_name: 'NonSrsModal' },
    },
  ]

  const handleOnClose = () => {
    setIsModalOpen(false)
    trackSnowplow({
      event: { name: 'modal_close', data: {} },
      contexts: [{ name: 'modal', data: { modal_name: 'NonSRSLabModal' } }],
    })
  }

  return (
    <Modal width="sm" open={isModalOpen} onClose={handleOnClose} data-testid="non-srs-lab-modal">
      <div className="flex flex-col gap-y-6 items-center">
        <Icon icon="circle-info" className="text-primary h-8 md:h-10" />
        <Typography variant="h5" align="center">
          This is not a Sharp Rees-Stealy lab
        </Typography>

        <Typography id="message" align="center">
          If your doctor is part of Sharp Rees-Stealy Medical Group, this lab will not be able to
          complete your lab work.
        </Typography>
        <AnalyticsLink as={Link} asPassthru={NextLink} href={SRSLABSLINK} snowplow={{ contexts }}>
          View Sharp Rees-Stealy labs
        </AnalyticsLink>

        {/* close button */}
        <AnalyticsLink
          autoFocus
          as={Button}
          href={url ?? ''}
          width="full"
          snowplow={{ contexts }}
          algolia={{ conversion: { namespace, objectId } }}>
          Continue booking
        </AnalyticsLink>
      </div>
    </Modal>
  )
}

export default NonSRSLabModal
